import { IRequestCommand } from '../../authentication/connection/iRequestCommand';
import { CommandRequestType } from '../../authentication/connection/commandRequestType';
import { ICommandParameters } from '../../authentication/connection/iCommandParameters';
import { ICommandResponse } from '../../authentication/connection/iCommandResponse';
import {
  ErrorDetails,
  DriverRegistrationResponseDTO,
  DriverRequestDTO, CreditDebitNoteRequestDTO
} from '../../interfaces/apiInterfaces';

export enum MovementForEnum {
  DRIVER, OWNER
}

export class AddCheckingAccountMovementCommand extends IRequestCommand<
  IAddCheckingAccountMovement,
  ErrorDetails,
  IAddCheckingAccountMovementParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.PUT;
  override _commandUrl = 'carriers/{carrierUserId}/drivers/{driverUserId}/addNote/{subUserId}';
  public override setParameters(parameters: IAddCheckingAccountMovementParameters) {
    this.urlSections.push('carriers');
    this.urlSections.push(`${parameters.carrierUserId.toString()}`);
    this.urlSections.push(parameters.movementFor === MovementForEnum.DRIVER ? 'drivers' : 'vehicleOwners');
    this.urlSections.push(`${parameters.id.toString()}`);
    this.urlSections.push('addNote');
    this.urlSections.push(`${parameters.subUserId.toString()}`)
    this._commandBody = parameters;
    this.composeUrl();
  }
}

export interface IAddCheckingAccountMovementParameters
  extends ICommandParameters,
  CreditDebitNoteRequestDTO {
  carrierUserId?: number;
  id?: number;
  movementFor: MovementForEnum;
  subUserId?: number;
}

export interface IAddCheckingAccountMovement
  extends DriverRegistrationResponseDTO,
  ICommandResponse { }
